import React from 'react'
import NotFound from '../notfound'

const NotFoundPl = () => {
    return <NotFound languageCode="pl" />
}

export default NotFoundPl
